/**
 * Quote Header — the original centered-logo header, restored for the embed (2026-07-07, per Edan).
 * Rolling Suds logo centered + "Back to Home" on the left. The form is embedded in an iframe on
 * rollingsudsdupage.com, so the links use target="_top" to navigate the PARENT window back to the
 * main site (the app's own landing page no longer exists in form-only mode). The logo is the live
 * site's own logo so it matches rollingsudsdupage.com exactly.
 *
 * NOTE on centering: the original used justify-between + a fixed right spacer, which balanced the
 * "Back to Home" TEXT on wide screens. In the narrow iframe that text is hidden (only the arrow
 * shows), so that layout pushed the logo to the left. Fixed by centering the logo (justify-center)
 * and absolutely positioning "Back to Home" on the left, so the logo stays centered at any width.
 */
import { ArrowLeft } from "lucide-react";

const HOME_URL = "https://rollingsudsdupage.com";
const LOGO_SRC = "https://rollingsudsdupage.com/wp-content/uploads/2026/06/cropped-Updated-Teal-Logo.png";

export default function QuoteHeader() {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-center h-24">
          <a
            href={HOME_URL}
            target="_top"
            rel="noopener"
            className="absolute left-0 flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="hidden sm:inline">Back to Home</span>
          </a>
          <a
            href={HOME_URL}
            target="_top"
            rel="noopener"
            className="flex items-center gap-2"
            aria-label="Rolling Suds DuPage — home"
          >
            <img
              src={LOGO_SRC}
              alt="Rolling Suds DuPage"
              className="h-20 w-auto"
            />
          </a>
        </div>
      </div>
    </header>
  );
}
